import { CALL_API, Schemas } from '../../common/middleware/api';
import { consts } from '../../common/reducers/junction'

export const WEEKLY_PROGRAMS_REQUEST = 'WEEKLY_PROGRAMS_REQUEST';
export const WEEKLY_PROGRAMS_SUCCESS = 'WEEKLY_PROGRAMS_SUCCESS';
export const WEEKLY_PROGRAMS_FAILURE = 'WEEKLY_PROGRAMS_FAILURE';

export const WEEKLY_PROGRAMS_UNPAGED_REQUEST = 'WEEKLY_PROGRAMS_UNPAGED_REQUEST';
export const WEEKLY_PROGRAMS_UNPAGED_SUCCESS = 'WEEKLY_PROGRAMS_UNPAGED_SUCCESS';
export const WEEKLY_PROGRAMS_UNPAGED_FAILURE = 'WEEKLY_PROGRAMS_UNPAGED_FAILURE';

export const WEEKLY_PROGRAMS_COPY_REQUEST = 'WEEKLY_PROGRAMS_COPY_REQUEST';
export const WEEKLY_PROGRAMS_COPY_SUCCESS = 'WEEKLY_PROGRAMS_COPY_SUCCESS';
export const WEEKLY_PROGRAMS_COPY_FAILURE = 'WEEKLY_PROGRAMS_COPY_FAILURE';

export const WEEKLY_PROGRAM_FETCH_REQUEST = 'WEEKLY_PROGRAM_GET_REQUEST';
export const WEEKLY_PROGRAM_FETCH_SUCCESS = 'WEEKLY_PROGRAM_GET_SUCCESS';
export const WEEKLY_PROGRAM_FETCH_FAILURE = 'WEEKLY_PROGRAM_GET_FAILURE';

export const WEEKLY_PROGRAM_CREATE_REQUEST = 'WEEKLY_PROGRAM_CREATE_REQUEST';
export const WEEKLY_PROGRAM_CREATE_SUCCESS = 'WEEKLY_PROGRAM_CREATE_SUCCESS';
export const WEEKLY_PROGRAM_CREATE_FAILURE = 'WEEKLY_PROGRAM_CREATE_FAILURE';

export const WEEKLY_PROGRAM_UPDATE_REQUEST = 'WEEKLY_PROGRAM_UPDATE_REQUEST';
export const WEEKLY_PROGRAM_UPDATE_SUCCESS = 'WEEKLY_PROGRAM_UPDATE_SUCCESS';
export const WEEKLY_PROGRAM_UPDATE_FAILURE = 'WEEKLY_PROGRAM_UPDATE_FAILURE';

export const LOCK_WEEKLY_PROGRAM_REQUEST = 'LOCK_WEEKLY_PROGRAM_REQUEST';
export const LOCK_WEEKLY_PROGRAM_SUCCESS = 'LOCK_WEEKLY_PROGRAM_SUCCESS';
export const LOCK_WEEKLY_PROGRAM_FAILURE = 'LOCK_WEEKLY_PROGRAM_FAILURE';

export const UNLOCK_WEEKLY_PROGRAM_REQUEST = 'UNLOCK_WEEKLY_PROGRAM_REQUEST';
export const UNLOCK_WEEKLY_PROGRAM_SUCCESS = 'UNLOCK_WEEKLY_PROGRAM_SUCCESS';
export const UNLOCK_WEEKLY_PROGRAM_FAILURE = 'UNLOCK_WEEKLY_PROGRAM_FAILURE';

export const CLOSE_WEEKLY_PROGRAM_REQUEST = 'CLOSE_WEEKLY_PROGRAM_REQUEST';
export const CLOSE_WEEKLY_PROGRAM_SUCCESS = 'CLOSE_WEEKLY_PROGRAM_SUCCESS';
export const CLOSE_WEEKLY_PROGRAM_FAILURE = 'CLOSE_WEEKLY_PROGRAM_FAILURE';

export const OPEN_WEEKLY_PROGRAM_REQUEST = 'OPEN_WEEKLY_PROGRAM_REQUEST';
export const OPEN_WEEKLY_PROGRAM_SUCCESS = 'OPEN_WEEKLY_PROGRAM_SUCCESS';
export const OPEN_WEEKLY_PROGRAM_FAILURE = 'OPEN_WEEKLY_PROGRAM_FAILURE';

export const LESSON_DATES_REQUEST = 'LESSON_DATES_REQUEST';
export const LESSON_DATES_SUCCESS = 'LESSON_DATES_SUCCESS';
export const LESSON_DATES_FAILURE = 'LESSON_DATES_FAILURE';

export const WEEKLY_PROGRAM_DELETE_REQUEST = 'WEEKLY_PROGRAM_DELETE_REQUEST';
export const WEEKLY_PROGRAM_DELETE_SUCCESS = 'WEEKLY_PROGRAM_DELETE_SUCCESS';
export const WEEKLY_PROGRAM_DELETE_FAILURE = 'WEEKLY_PROGRAM_DELETE_FAILURE';

export const WEEKLY_PROGRAM_VALIDATE_DELETE_REQUEST = 'WEEKLY_PROGRAM_VALIDATE_DELETE_REQUEST';
export const WEEKLY_PROGRAM_VALIDATE_DELETE_SUCCESS = 'WEEKLY_PROGRAM_VALIDATE_DELETE_SUCCESS';
export const WEEKLY_PROGRAM_VALIDATE_DELETE_FAILURE = 'WEEKLY_PROGRAM_VALIDATE_DELETE_FAILURE';

export const WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_REQUEST = 'WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_REQUEST';
export const WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_SUCCESS = 'WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_SUCCESS';
export const WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_FAILURE = 'WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_FAILURE';

export const WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_REQUEST = 'WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_REQUEST';
export const WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_SUCCESS = 'WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_SUCCESS';
export const WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_FAILURE = 'WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_FAILURE';

export const loadWeeklyProgram = (options) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAMS_REQUEST, WEEKLY_PROGRAMS_SUCCESS, WEEKLY_PROGRAMS_FAILURE],
		endpoint: 'api/weeklyPrograms',
		request: options,
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

export const loadUnpagedWeeklyProgram = (options) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAMS_UNPAGED_REQUEST, WEEKLY_PROGRAMS_UNPAGED_SUCCESS, WEEKLY_PROGRAMS_UNPAGED_FAILURE],
		endpoint: 'api/weeklyPrograms/unpaged',
		request: options,
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

export const copyWeeklyProgram = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAMS_COPY_REQUEST, WEEKLY_PROGRAMS_COPY_SUCCESS, WEEKLY_PROGRAMS_COPY_FAILURE],
		endpoint: 'api/weeklyPrograms/copy',
		request: options,
		form: 'weeklyProgramCopy',
		schema: Schemas.WEEKLY_PROGRAM_ARRAY,
		onSuccessEvent
	}
});

export const fetchWeeklyProgram = (id) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAM_FETCH_REQUEST, WEEKLY_PROGRAM_FETCH_SUCCESS, WEEKLY_PROGRAM_FETCH_FAILURE],
		endpoint: `api/weeklyPrograms/${id}`,
		schema: Schemas.WEEKLY_PROGRAM
	}
});

export const createWeeklyProgram = (program, history, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAM_CREATE_REQUEST, WEEKLY_PROGRAM_CREATE_SUCCESS, WEEKLY_PROGRAM_CREATE_FAILURE],
		endpoint: 'api/weeklyPrograms',
		method: 'POST',
		request: program,
		schema: Schemas.WEEKLY_PROGRAM,
		form: 'weeklyProgram',
		onSuccessEvent
	}
});

export const updateWeeklyProgram = (id, program, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAM_UPDATE_REQUEST, WEEKLY_PROGRAM_UPDATE_SUCCESS, WEEKLY_PROGRAM_UPDATE_FAILURE],
		endpoint: `api/weeklyPrograms/${id}`,
		method: 'PUT',
		request: program,
		schema: Schemas.WEEKLY_PROGRAM,
		form: 'weeklyProgram',
		onSuccessEvent
	}
});

export const lockWeeklyProgram = (termId, centerId, status) => ({
	[CALL_API]: {
		types: [LOCK_WEEKLY_PROGRAM_REQUEST, LOCK_WEEKLY_PROGRAM_SUCCESS, LOCK_WEEKLY_PROGRAM_FAILURE],
		endpoint: `api/weeklyPrograms/lockAll`,
		method: 'PUT',
		request: { termId, centerId, status},
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

export const closeWeeklyProgram = (termId, centerId, status) => ({
	[CALL_API]: {
		types: [CLOSE_WEEKLY_PROGRAM_REQUEST, CLOSE_WEEKLY_PROGRAM_SUCCESS, CLOSE_WEEKLY_PROGRAM_FAILURE],
		endpoint: `api/weeklyPrograms/closeAll`,
		method: 'PUT',
		request: { termId, centerId, status },
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

export const openWeeklyProgram = (termId, centerId, status) => ({
	[CALL_API]: {
		types: [OPEN_WEEKLY_PROGRAM_REQUEST, OPEN_WEEKLY_PROGRAM_SUCCESS, OPEN_WEEKLY_PROGRAM_FAILURE],
		endpoint: `api/weeklyPrograms/openAll`,
		method: 'PUT',
		request: { termId, centerId, status },
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

export const unlockWeeklyProgram = (termId, centerId, status) => ({
	[CALL_API]: {
		types: [UNLOCK_WEEKLY_PROGRAM_REQUEST, UNLOCK_WEEKLY_PROGRAM_SUCCESS, UNLOCK_WEEKLY_PROGRAM_FAILURE],
		endpoint: `api/weeklyPrograms/unlockAll`,
		method: 'PUT',
		request: { termId, centerId, status },
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

export const joinCenterTerm = (centerId, termId) => ({
	type: consts.action,
	payload: {
		junctions: {
			[consts.keys.CENTER_TERM_PROGRAM]: {
				[centerId]: { centerId, termId }
			}
		}
	}
});

export const loadLessonDates = (weeklyProgramItemId) => (dispatch, getState) => {
	const lessonDates = getState().entities.lessonDates[weeklyProgramItemId];
	if (lessonDates) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [LESSON_DATES_REQUEST, LESSON_DATES_SUCCESS, LESSON_DATES_FAILURE],
			endpoint: `api/weeklyPrograms/lessonDates`,
			request: { id: weeklyProgramItemId },
			schema: Schemas.LESSON_DATES
		}
	});
};

export const deleteWeeklyProgram = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAM_DELETE_REQUEST, WEEKLY_PROGRAM_DELETE_SUCCESS, WEEKLY_PROGRAM_DELETE_FAILURE],
		endpoint: `api/weeklyPrograms/${id}`,
		method: 'DELETE',
		schema: Schemas.WEEKLY_PROGRAM,
		form: 'weeklyProgram',
		onSuccessEvent
	}
});

export const validateDelete = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAM_VALIDATE_DELETE_REQUEST, WEEKLY_PROGRAM_VALIDATE_DELETE_SUCCESS, WEEKLY_PROGRAM_VALIDATE_DELETE_FAILURE],
		endpoint: `api/weeklyPrograms/validateDelete/${id}`,
		method: 'GET',
		form: 'weeklyProgram',
		onSuccessEvent
	}
});

export const loadAutoEnrolPreview = ({ centerId, termId }, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_REQUEST, WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_SUCCESS, WEEKLY_PROGRAMS_AUTO_ENROL_PREVIEW_FAILURE],
		endpoint: 'api/weeklyPrograms/auto-enrol/preview',
		method: 'GET',
		request: { centerId, termId },
		onSuccessEvent
	}
});

export const executeAutoEnrol = ({ centerId, termId, selections, confirmOverCapacity }, onSuccessEvent, onErrorEvent) => ({
	[CALL_API]: {
		types: [WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_REQUEST, WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_SUCCESS, WEEKLY_PROGRAMS_AUTO_ENROL_EXECUTE_FAILURE],
		endpoint: `api/weeklyPrograms/auto-enrol?centerId=${centerId}&termId=${termId}`,
		method: 'POST',
		request: { selections, confirmOverCapacity },
		form: 'autoEnrol',
		onSuccessEvent,
		onErrorEvent
	}
});